import { useEffect, useState } from "react";
import { useAuth } from "reactfire";

const useIdToken = () => {
  const auth = useAuth();
  const [idToken, setIdToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    // Set up auth state listener to react to login/logout
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        user.getIdToken().then((token) => {
          setIdToken(token);
        });
      } else {
        setIdToken(undefined);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  return idToken;
};

export default useIdToken;
